<template>
    <div class="layout-footer">
        <div class="layout-footer--inner">
            <flex justify="between" class="p-2 p-md-3 mx-2">
                <a href="http://www.ghst.de/">
                    <img src="/img/hertie-logo-weis.svg" alt="Hertie Stiftung" class="layout-footer--logo" target="_blank">
                </a>
                <div class="ml-2 flex-shrink-0">
                    <div>
                        <btn theme="none" route="landing_impress">Impressum</btn>
                        <span class="px-1">|</span>
                        <btn theme="none" route="landing_privacy">Datenschutz</btn>
                    </div>
                    <div>
                        © {{ year }} <a href="https://www.start-stiftung.de/" target="_blank" class="about">START-Stiftung gGmbH</a>.
                    </div>
                </div>
            </flex>
        </div>
    </div>
</template>

<style lang="scss">
    .layout-footer {
        background-color: rgba($black, .5);
        color: $white;
        z-index: 1;
        font-size: $font-size-sm;
    }
    .layout-footer--inner {
        max-width: $layout-max-width;
        width: 100%;
        margin: 0 auto;
        padding: 0 $layout-sidebar-width;

        a {
            color: $white;
        }
        a:hover {
            text-decoration: underline;
        }
    }
    .layout-footer--logo {
        height: 60px;
    }

    @include media-breakpoint-down("lg") {
        .layout-footer--inner {
            padding-left: 0;
        }
    }
    @include media-breakpoint-down("md") {
        .layout-footer--inner {
            display: none;
        }
    }
</style>

<script>
    export default {
        data() {
            return {
                year: new Date().getFullYear(),
            };
        },
    };
</script>